
export type GetMetricTypes401 = {
  error?: string;
};
